import { display } from '@material-ui/system'
import styled from 'styled-components'

export const PopoverTriggerStyled = styled.div`
  display: inline-block;

  ${display}
`
